/**
 * Created by Alex Xia on 07/27/2020.
 * Description:
 * Add Auto Tag for Admin Console
 * ------ maintenance history ------
 */
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { AdminPageSetting } from '../../admin-page-setting.model';
import { ActivatedRoute } from '@angular/router';
import { adminPageRoutingMap } from '../../admin-page-setting.constants';
import { AutoTagging } from '../../../../tamalelibs/models/auto-tagging.model';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as _lodash from 'lodash';
import { lastCustomActionSelector } from '../../../../redux/reducers/action-history.reducer';
import { ToastService } from '../../../../widgets/toast/toast.service';
import { NotificationStyles } from '../../../../widgets/notification/notification.model';
import { AppState } from '../../../../redux';
import { businessConstants } from '../../../../tamalelibs/constants/business.constants';
import { fullEntryTypeSelector } from '../../../../redux/reducers/entry-type.reducer';
import { MultiSelDropdownFilterConfig } from '../../../../widgets/multi-sel-dropdown-filter/multi-sel-dropdown-filter.model';
import { getSystemConfigState } from '../../../../redux/reducers/system-config-view.reducer';
import { StoreQuerierService } from '../../../../services/store-querier.service';
import { getAutoTagModelState } from '../../../../redux/reducers/auto-tagging-view.reducer';
import { AutoTagModelDialogOpenOptions } from '../autotag-model-dialog/autotag-model-dialog.model';
import { MultiSelDropdownFilterComponent } from '../../../../widgets/multi-sel-dropdown-filter/multi-sel-dropdown-filter.component';
import { UtilsService } from '../../../../tamalelibs/services/utils.service';
import {
    EDIT_AUTO_TAG_SETTINGS, EDIT_AUTO_TAG_SETTINGS_SUCCESS, EDIT_AUTO_TAG_SETTINGS_FAIL,
    GET_AUTO_TAG_MODEL, CHANGE_AUTO_TAG_STATUS, CHANGE_AUTO_TAG_STATUS_SUCCESS, CHANGE_AUTO_TAG_STATUS_FAIL, CHANGE_AUTO_TAG_STATUS_FOR_LIVEWIRE, CHANGE_AUTO_TAG_STATUS_FOR_LIVEWIRE_SUCCESS
} from '../../../../tamalelibs/redux/auto-tagging.actions';
import { AutoTagDialogService } from '../autotag-model-dialog/autotag-model-dialog.service';
import { AutoTagModelDialogType } from '../autotag-model-dialog/autotag-model-dialog.model';
import { ArrayHelperService } from '../../../../tamalelibs/services/array-helper.service';


@Component({
    selector: 'tam-admin-page-autotag',
    templateUrl: './admin-autotag-page.component.html',
    styleUrls: ['./admin-autotag-page.component.scss']
})
export class AdminAutoTagPageComponent implements OnInit, OnDestroy {
    @ViewChild(MultiSelDropdownFilterComponent, { static: false }) multiSelDropdownEle: MultiSelDropdownFilterComponent;
    currPage: AdminPageSetting;
    currPageUrl: string;

    autoTagging = new AutoTagging();
    oldAutoTagging = new AutoTagging(); // used to check if there were any changes

    allNoteTypes = [];
    selectedNoteTypes: string;
    selectedModel = {
        text: 'Tamale Auto Tag Model',
        value: 'Tamale Auto Tag Model'
    };
    btnSaveDisabled = true;
    btnCancelDisabled = true;
    toogleEnabled: boolean;
    isProgressing = false;
    modelDisabled = false;

    dropdownConfig: MultiSelDropdownFilterConfig = new MultiSelDropdownFilterConfig();
    modelData: Array<{ text: string, value: string }> = [];
    toastMsg: string;

    private _subscribed = false;
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _route: ActivatedRoute,
        private _store: Store<AppState>,
        private _toast: ToastService,
        private _utilsService: UtilsService,
        private _service: AutoTagDialogService,
        private _storeQuerier: StoreQuerierService,
    ) {
    }

    ngOnInit() {
        this._handlePageRouting(this._route.snapshot.data['page']);
        this._initAutoTag();
        this._initSubscriptions();
        this._getAutoTagModel();
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
        this._subscribed = false;
    }

    /*
    *  only enable or disable autotag status, not affect other fields
    */
    changeAutoTaggingStatus(value) {
        this.autoTagging.enable = value;

        this._changeAutoTagStatus();
    }

    /*
    *  only enable or disable autotag status for live wire, not affect other fields
    */
    changeAutoTaggingStatusForLivewire(value) {
        this.autoTagging.enableForLiveWire = value;

        this._changeAutoTagStatusForLiveWire();
    }

    changeConfidence() {
        this._setButtonEnableStatus();
    }

    changeTaggingModel(event) {
        this.autoTagging.model = event.text;
        this._setButtonEnableStatus();
    }

    /*
    * click 'Cancel' to discard the changes except enable status
    */
    onCancel() {
        const enableStatus = this.autoTagging.enable;
        this.autoTagging = _lodash.cloneDeep(this.oldAutoTagging);
        this.autoTagging.enable = enableStatus;
        // cancel the change of Model Name
        this.selectedModel = {
            text: this.autoTagging.model,
            value: this.autoTagging.model
        };

        // cancel the change of Note Types
        this._store.pipe(select(fullEntryTypeSelector))
            .subscribe(res => this._onSubscribeNoteTypesList(res));

        if (this.multiSelDropdownEle) {
            this.multiSelDropdownEle.formatValue(true);
        }

        this._setBtnStatus(true, true);
    }

    onCreateNewModel() {
        const _autoTagModelDialogOpenOptions = new AutoTagModelDialogOpenOptions();
        _autoTagModelDialogOpenOptions.openType = AutoTagModelDialogType.CreateModel;
        this._service.dialogOpen$.next(_autoTagModelDialogOpenOptions);
    }

    onSave() {
        this.isProgressing = true;
        this.oldAutoTagging = _lodash.cloneDeep(this.autoTagging);
        this._editAutoTagSettings();
    }

    private _changeAutoTagStatus() {
        this._store.dispatch({
            type: CHANGE_AUTO_TAG_STATUS,
            payload: this.autoTagging
        });
    }

    private _changeAutoTagStatusForLiveWire() {
        this._store.dispatch({
            type: CHANGE_AUTO_TAG_STATUS_FOR_LIVEWIRE,
            payload: this.autoTagging
        });
    }

    private _initAutoTag() {
        const systemConfig = this._storeQuerier.queryBySelector(getSystemConfigState);
        this.autoTagging = systemConfig.autotag;
        this.selectedModel = {
            text: this.autoTagging.model,
            value: this.autoTagging.model
        };

        this.oldAutoTagging = _lodash.cloneDeep(this.autoTagging);
    }

    private _editAutoTagSettings() {
        this._store.dispatch({
            type: EDIT_AUTO_TAG_SETTINGS,
            payload: this.autoTagging
        });
    }

    private _getAutoTagModel() {
        this._store.dispatch({
            type: GET_AUTO_TAG_MODEL,
            payload: ''
        });
    }

    private _getAllCheckedNoteTypeIds(checkedNoteTypes: Array<any>): string {
        const noteTypeIds = [];
        if (checkedNoteTypes) {
            checkedNoteTypes.forEach(item => {
                noteTypeIds.push(item.id);
            });
        }
        return noteTypeIds.length > 0 ? noteTypeIds.join(',') : '';
    }

    private _handlePageRouting(currPageUrl: string) {
        this.currPageUrl = currPageUrl;
        this.currPage = adminPageRoutingMap.get(this.currPageUrl);
    }

    private _initSubscriptions() {
        if (!this._subscribed) {
            this._subscribed = true;

            this._destroySubscriptions.push(

                this._store.pipe(
                    select(lastCustomActionSelector)
                ).subscribe(action => {
                    this._onSubscribeActionMessage(action);
                }),

                this._store.pipe(select(fullEntryTypeSelector))
                    .subscribe(res => this._onSubscribeNoteTypesList(res)),

                this._store.pipe(select(getAutoTagModelState))
                    .subscribe(res => this._onSubscribeAutoTagModelList(res))
            );

            this.dropdownConfig.onChangeValue$.subscribe(data => {
                const value = typeof data === 'string' ? data : data.map(item => item.id);
                if (value === 'all') {
                    const checkedNoteTypes = this.multiSelDropdownEle.getCheckedData();
                    this.selectedNoteTypes = this._getAllCheckedNoteTypeIds(checkedNoteTypes);
                } else {
                    this.selectedNoteTypes = (value) ? value.join(',') : '';
                }

                // set enable/disable status for save/cancel button
                this.autoTagging.noteTypes = this.selectedNoteTypes;
                this._setButtonEnableStatus();
            });
        }
    }

    private _setButtonEnableStatus() {
        if (this._utilsService.isEqual(this.oldAutoTagging, this.autoTagging)) {
            this._setBtnStatus(true, true);
        } else {
            if (this.autoTagging.noteTypes && this.autoTagging.model && this.autoTagging.confidence >= 0.2 && this.autoTagging.confidence <= 1.0) {
                this._setBtnStatus(false, false);
            } else if (!this.autoTagging.noteTypes || this.autoTagging.confidence < 0.2 || this.autoTagging.confidence > 1.0) {
                this._setBtnStatus(true, false);
            } else {
                this._setBtnStatus(true, true);
            }
        }
    }

    private _setBtnStatus(btnSaveStatus: boolean, btnCancleStatus: boolean) {
        this.btnSaveDisabled = btnSaveStatus;
        this.btnCancelDisabled = btnCancleStatus;
        this.isProgressing = false;
    }

    private _onSubscribeActionMessage(action) {
        if (action.type === EDIT_AUTO_TAG_SETTINGS_SUCCESS) {
            this.toastMsg = `Auto Tag model '${this.autoTagging.model}' applied successfully`;
            // Cancel and Save button should turn to disabled after saving successfully
            this._setBtnStatus(true, true);

            this._toast.notify({
                message: this.toastMsg,
                style: NotificationStyles.Success
            });
        } else if (action.type === CHANGE_AUTO_TAG_STATUS_SUCCESS) {
            this.isProgressing = false;
            if (this.autoTagging.enable) {
                this.modelDisabled = false;
                this.toastMsg = businessConstants.autoTag.autoTagEnabledMsg;
            } else {
                // disable auto tagging model
                this.modelDisabled = true;
                this.toastMsg = businessConstants.autoTag.autoTagDisabledMsg;
            }

            this._toast.notify({
                message: this.toastMsg,
                style: NotificationStyles.Success
            });
        } else if (action.type === CHANGE_AUTO_TAG_STATUS_FOR_LIVEWIRE_SUCCESS) {
            this.isProgressing = false;
            if (this.autoTagging.enableForLiveWire) {
                this.toastMsg = businessConstants.autoTag.autoTagEnabledForLiveWireMsg;
            } else {
                this.toastMsg = businessConstants.autoTag.autoTagDisableForLiveWiredMsg;
            }

            this._toast.notify({
                message: this.toastMsg,
                style: NotificationStyles.Success
            });
        } else if (action.type === EDIT_AUTO_TAG_SETTINGS_FAIL || action.type === CHANGE_AUTO_TAG_STATUS_FAIL) {
            this.toastMsg = action.payload;
            this.isProgressing = false;
            this._toast.notify({
                message: this.toastMsg,
                style: NotificationStyles.Error
            });
        }
    }

    private _onSubscribeAutoTagModelList(res: any) {
        this.modelData = [];
        if (res && res.models && res.models.length > 0) {
            res.models.forEach(model => {
                this.modelData.push({ text: model, value: model });
            });
        }
    }

    private _isNoteTypeExisted(id: string) {
        if (this.autoTagging.noteTypes.includes(id)) {
            return true;
        } else {
            return false;
        }
    }

    private _onSubscribeNoteTypesList(item: Array<any>): void {
        this.allNoteTypes = item;
        if (this.allNoteTypes) {
            if (item && item.length > 0) {
                ArrayHelperService.sort(item, 'name');

                this.dropdownConfig.data = item.map(data => {
                    return {
                        id: data.id,
                        checked: this._isNoteTypeExisted(data.id) ? true : false,
                        name: data.name
                    };
                });
            }
        }
    }
}
